export const controllPalletTranslationTH = {
  controllPallet: {
    "controllPallet_title": "รายการใบรับรองพาเลท",
    "controllPallet_newPallet": "พาเลทใหม่",
    "controllPallet_printSuccess": "พิมพ์พาเลทสำเร็จ",
    "controllPallet_printError": "เกิดข้อผิดพลาดในการพิมพ์พาเลท",
    "controllPallet_deleteSuccess": "ลบพาเลทสำเร็จ",
    "controllPallet_deleteError": "ไม่ได้ลบพาเลท",
    
    // From ControlPalletsTitle.jsx
    "controllPallet_update": "อัพเดต",
    "controllPallet_delete": "ลบ",
    
    // From AddPalletDetailes.jsx
    "controllPallet_newPalletTitle": "พาเลทใหม่",
    "controllPallet_palletWithId": "พาเลท: {{id}}",
    "controllPallet_customerUpdated": "อัพเดตลูกค้าสำเร็จ",
    "controllPallet_customerNotUpdated": "ไม่ได้อัพเดตลูกค้า",
    "controllPallet_itemDeleted": "ลบรายการสำเร็จ",
    "controllPallet_chooseCustomer": "เลือกลูกค้า",
    "controllPallet_finish": "เสร็จสิ้น",
    "controllPallet_newProduct": "สินค้าใหม่",
    "controllPallet_updateItem": "อัพเดตรายการ",
    "controllPallet_externalPalletNumber": "หมายเลขพาเลทภายนอก",
    "controllPallet_dividePallet": "แบ่งพาเลท: {{palletNum}}",
    "controllPallet_dividePallet_notification_overflow": "จำนวนกระปุกสำหรับแบ่งมากเกินไป"
  }
}; 